import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { DeleteOutlineOutlined as DeleteIcon } from "@mui/icons-material";

import Loader from "components/Custom/Loader";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import UiAccordion from "components/Custom/UiAccordion";
import { ERRORS, LABELS, SUCCESS, TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";

import { TRANS_APIs } from "apihandlers/transaction";
import { IconButton, Tooltip } from "@mui/material";
import { COMMON_JS } from "common/scripts";
import PurchaseReturnSkeleton from "./PurchaseReturnSkeleton";
import PurchaseReturnBillPrint from "./print/PurchaseReturnBillPrint";
import UiDialog from "components/Custom/UiDialog";
import {ORDER_APIs} from "apihandlers/order"


const PurchaseReturn = (props: any) => {
  const { setDashMenu } = props;

  const purchaseReturnRef: any = useRef(null);
  const purchaseReturnChildRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [managePrintDialog, setManagePrintDialog] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const purchaseReturnCols = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "expanded",
    },
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "orderNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ORIG_BILL_NO,
      width: "10%",
    },
    {
      key: "orderDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ORIG_DATE,
      width: "10%",
    },
    {
      key: "purchaseReturnNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PURCHASE_RETURN_NO,
      width: "15%",
    },
    {
      key: "purchaseReturnDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PURCHASE_RETURN_DATE,
      width: "15%",
    },
    {
      key: "totalQty",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NO_OF_ITEMS,
      width: "15%",
    },
    {
      key: "total",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ITEM_AMOUNT,
      width: "15%",
    },
    {
      key: "billAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BILL_AMOUNT,
      width: "15%",
    },
  ];

  const itemCols = [
    {
      key: "productId",
      type: "text",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.PRODUCT_NAME,
      width: "35%",
    },
    {
      key: "qty",
      type: "number",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.QTY,
      width: "20%",
    },
    {
      key: "price",
      type: "number",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.RATE,
      width: "25%",
    },
    {
      key: "amount",
      type: "number",
      formula: "qty * price",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.AMOUNT,
      width: "20%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.DELETE} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onDelete(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const fromDate = (
        document.getElementById("fromDate") as HTMLInputElement
      ).value.trim();
      const toDate = (
        document.getElementById("toDate") as HTMLInputElement
      ).value.trim();
      const args = {
        isSale: "false",
        isReturn: "true",
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        fromDate,
        toDate,
      };
      setRows(null);
      const res: any = await ORDER_APIs.getOrders(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          list[i]["_type"] = "maingrid";
          list[i]["_expanded"] = false;
          let subList = list[i].items;
          let orderId = list[i].id;
          for (let j = 0; j < subList.length; j++) {
            subList[j]["slNo"] = j + 1;
          }
          list[i]["_subGrid"] = () => subGrid(subList, orderId);
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getPurchaseReturn:", error);
    }
  };

  const onDelete = (row: any) => {
    purchaseReturnChildRef.deleteRow(row.id);
    const args = {
      orderItemId: row.id,
    };
    TRANS_APIs.deleteOrderItem(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_DELETE);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const subGrid = (subRows = [], orderId) => {
    return (
      <>
        <ExcelGrid
          id={"purchaseReturnSubGrid"}
          childRef={purchaseReturnChildRef}
          cols={itemCols}
          rows={subRows}
          isSubGrid={true}
          noTotalRows={true}
          getDefaultNewRow={() => {
            getDefaultNewRow(orderId);
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "right",
            width: "99%",
          }}
        >
          <div
            style={{
              width: "35%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Btn
              text={LABELS.SAVE}
              onClick={managePurchaseBill}
              marginRight={15}
              bgColor={COLORS.GRID_ADD_NEW}
              //  loading={isSubmit}
            />
          </div>
        </div>
      </>
    );
  };

  const getDefaultNewRow = (orderId) => {
    const newRow: any = {
      id: orderId + purchaseReturnChildRef.getRowData().length + 1,
      orderId: orderId,
      orderItemId: -1,
      productId: "",
      price: "",
      sold: "",
    };
    console.log("newRow", newRow);
    return newRow;
  };

  const managePurchaseBill = () => {
    let gridRows = purchaseReturnChildRef.getRowData();
    const args = {
      rows: gridRows.map((r) => {
        return {
          orderId: r.orderId,
          orderItemId: r.orderItemId,
          productId: r.productIdId,
          sold: r.sold,
        };
      }),
    };
    console.log("gridRowsargs", args);
    return;
    ORDER_APIs.manageOrders(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };
  const printPurchaseReturn = (e) => {
    const returnRow = purchaseReturnRef.getSelectedRows();
    if (returnRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManagePrintDialog(true);
      if (managePrintDialog === true) {
        const html = document.getElementById("PurchaseReturnBill").innerHTML;
        COMMON_JS.printHtml(html);
      }
    }
  };

  return (
    <React.Fragment>
      {
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
            <li className="dim">{" / "}</li>
            <li onClick={() => props.setDashMenu(LABELS.HOME)}>
              {LABELS.PURCHASE}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.PURCHASE_RETURN}</li>
          </ul>
          <h4>{TITLES.PURCHASE_RETURN}</h4>
        </div>
      }
      <div className=" filterBorder" style={{ width: "96%" }}>
        <UiAccordion id={"filter"} title={LABELS.FILTER}>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.FROM_DATE}
                type={"date"}
                id="fromDate"
                defaultValue={DateFunctions.getDate(
                  "2days",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.TO_DATE}
                type={"date"}
                id="toDate"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>
            <div className="formGroup width30">
              <div style={{ marginTop: "1.5rem" }}>
                <Btn
                  text={LABELS.LOAD}
                  onClick={getRows}
                  bgColor={COLORS.GRID_ADD_NEW}
                  // loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiAccordion>
      </div>
      {rows ? (
        <div className="grid excelGridWrapper">
          <ExcelGrid
            id={"purchaseReturn"}
            childRef={purchaseReturnRef}
            height={window.innerHeight * 0.55}
            cols={purchaseReturnCols}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.PURCHASE_RETURN}
            onReload={reloadGrid}
            leftSideWidth={"50%"}
            rightSideWidth={"50%"}
            leftSideBtns={
              <div className="excelBtnWrapper">
                <Btn
                  text={LABELS.PRINT_PURCHASE_RETURN}
                  size={"medium"}
                  onClick={printPurchaseReturn}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                />
              </div>
            }
          />
        </div>
      ) : (
        <PurchaseReturnSkeleton />
      )}

      {managePrintDialog && (
        <UiDialog
          title={LABELS.PRINT_PURCHASE_RETURN + ": "}
          open={true}
          size={"md"}
          onClose={() => {
            setManagePrintDialog(false);
          }}
        >
          <div style={{ height: "100%" }}>
            <div
              style={{
                height: "70%",
                overflow: "auto",
                marginBottom: "1.5rem",
              }}
            >
              <PurchaseReturnBillPrint purchaseReturnRef={purchaseReturnRef} />
            </div>
            <div
              style={{
                margin: "0.5rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "right",
                width: "95%",
                zIndex: 999,
                position: "fixed",
                bottom: 0,
              }}
            >
              <div
                style={{
                  width: "35%",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Btn
                  text={LABELS.PRINT_SUMMARY}
                  onClick={printPurchaseReturn}
                  marginRight={15}
                  bgColor={COLORS.GRID_ADD_NEW}
                  //  loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(PurchaseReturn);
